/**
 * Static mock data for the Venue dashboard preview. Deterministic literals (not random) so
 * screenshots and any future snapshot stay stable. Replaced wholesale when the dashboard is
 * wired to real Booking / Visit / Sale data.
 */
import type { MoneyAmount } from '@/shared/i18n/formatMoney';

/** Today's expected revenue as a self-describing {@link MoneyAmount} (Serbia pilot → RSD). */
export const REVENUE_TODAY: MoneyAmount = { amount: 184_750_00, currency: 'RSD' };

/** Headline counts for the top-row summary cards. */
export const GUESTS_BOOKED_TODAY = 42;
export const ADMISSIONS_TODAY = 128;
export const ITEMS_SOLD_TODAY = 96;

export type AttendanceBucket = { hour: string; guests: number };

/** Expected guests per open hour today (09:00–22:00). */
export const EXPECTED_ATTENDANCE: AttendanceBucket[] = [
  { hour: '09:00', guests: 6 },
  { hour: '10:00', guests: 14 },
  { hour: '11:00', guests: 22 },
  { hour: '12:00', guests: 28 },
  { hour: '13:00', guests: 19 },
  { hour: '14:00', guests: 24 },
  { hour: '15:00', guests: 33 },
  { hour: '16:00', guests: 41 },
  { hour: '17:00', guests: 38 },
  { hour: '18:00', guests: 30 },
  { hour: '19:00', guests: 21 },
  { hour: '20:00', guests: 12 },
  { hour: '21:00', guests: 7 },
  { hour: '22:00', guests: 3 },
];
